import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef, useState } from 'react';
import Section from '../shared/Section/Section';
import Container from '../shared/Container/Container';
import Button from '../shared/Button/Button';
import NotifyMeModal from '../shared/NotifyMeModal/NotifyMeModal';
import { products } from '../../data/products';
import { trackCTAClick, trackModalInteraction } from '../../utils/analytics';
import './CTA.css';

const CTA = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const [modalProduct, setModalProduct] = useState<'wholesale' | 'ceramic' | null>(null);

  return (
    <>
      <Section background="dark">
        <Container>
          <div className="cta" ref={ref}>
            <motion.div
              className="cta__content"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8 }}
            >
              <h2 className="cta__title">Ready to Join the Rib Revolution?</h2>
              <p className="cta__description">
                Back in stock soon — sign up to get notified the moment they're available.
              </p>
              <div className="cta__buttons">
                <Button
                  variant="primary"
                  onClick={() => {
                    trackCTAClick('Notify Me – Wholesale Packs', 'notify', 'Wholesale Packs');
                    trackModalInteraction('notify_modal', 'open', 'Wholesale Packs');
                    setModalProduct('wholesale');
                  }}
                >
                  Notify Me – Wholesale Packs
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => {
                    trackCTAClick('Notify Me – Ceramic Edition', 'notify', 'Ceramic Edition');
                    trackModalInteraction('notify_modal', 'open', 'Ceramic Edition');
                    setModalProduct('ceramic');
                  }}
                >
                  Notify Me – Ceramic Edition
                </Button>
              </div>
            </motion.div>

            <motion.div
              className="cta__image"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={isInView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              {/* Image: cta_packaging_flatlay.jpg */}
              {/* Prompt: Flat-lay photo of both versions of Rib-n-Dip — one disposable plastic pack, one ceramic gift box — arranged neatly on a BBQ table with sauce bottles, napkins, and ribs around. */}
              <img
                src="/images/cta_packaging_flatlay.jpg"
                alt="Rib-n-Dip wholesale and ceramic BBQ rib dipping sauce cup packaging options for restaurants and home"
                className="cta__image-main"
                loading="lazy"
              />
            </motion.div>
          </div>
        </Container>
      </Section>

      {modalProduct && products[modalProduct] && (
        <NotifyMeModal
          isOpen={!!modalProduct}
          onClose={() => {
            trackModalInteraction('notify_modal', 'close', products[modalProduct]!.name);
            setModalProduct(null);
          }}
          productName={products[modalProduct]!.name}
          productId={products[modalProduct]!.id}
        />
      )}
    </>
  );
};

export default CTA;
